import styled from 'styled-components';

import { fieldContainer, fieldLabel, fieldMessage } from '../base';

/**
 * The design's `.dropzone`.
 *
 * It replaces a 220px white box with a `#e1dfec` dashed rule and an 8px
 * radius, holding an 80×68 `#e2e8f0` tile with an injected `#A4A6B3` glyph in
 * it and `#8a93ac` copy underneath — a box inside a box, with the icon's tile
 * reading as the target rather than the zone itself.
 *
 * Both call sites are group 8: the event cover and the news image.
 */

export const inputContainer = styled.div`
  ${fieldContainer}
`;

export const label = styled.label`
  ${fieldLabel}
`;

export const message = styled.span`
  ${fieldMessage}
`;

export const InputBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--s1);
  width: 100%;
  min-height: 160px;
  padding: var(--s6) var(--s4);
  text-align: center;
  background: var(--surface-alt);
  border: 1.5px dashed var(--line-strong);
  border-radius: var(--r-md);
  cursor: pointer;
  overflow: hidden;
  transition:
    background-color 0.12s,
    border-color 0.12s;

  &:hover,
  &.dragging {
    border-color: var(--primary);
    background: var(--primary-soft);
  }

  /* Once there is an image the zone is a preview, so it stops being padded
     and lets the picture reach the dashed edge. */
  &.filled {
    padding: 0;
    background: var(--surface);
  }
`;

export const img = styled.img`
  &.icon {
    display: block;
    width: 100%;
    max-height: 240px;
    object-fit: contain;
  }
`;

export const Icon = styled.div`
  display: grid;
  place-items: center;
  color: var(--text-faint);
  margin-bottom: var(--s2);
  line-height: 0;

  svg {
    width: 22px;
    height: 22px;
    stroke-width: 1.6;
  }
`;

export const Text = styled.p`
  font-size: var(--fs-label);
  font-weight: var(--fw-regular);
  line-height: var(--lh-body);
  color: var(--text-muted);
`;

/** The design's `.ratio` — the shape the image should be, in mono. */
export const Ratio = styled.p`
  font-family: var(--font-mono);
  font-size: var(--fs-micro);
  line-height: var(--lh-body);
  color: var(--text-faint);
`;

/** Replace / remove, once there is something to replace. */
export const Hint = styled.p`
  font-size: var(--fs-micro);
  line-height: var(--lh-body);
  color: var(--text-faint);
  margin-top: var(--s2);
`;
